import React from 'react';
import './States.css';

/**
 * Loading state for a whole page: a shimmering skeleton of a typical page (title, summary cards, table)
 * with a small status line at the very bottom of the page. It fades in after a short delay, so a fast load never flashes it.
 *
 * Usage:
 *   if (loading) return <PageLoader message="Cargando productos…" />;
 */
export default function PageLoader({ message = 'Cargando…' }) {
  return (
    <div className="page-loader dashboard-container" role="status" aria-live="polite">
      <div className="sk pl-title" />
      <div className="sk pl-sub" />
      <div className="pl-cards">
        {[0, 1, 2, 3].map(i => <div key={i} className="sk pl-card" />)}
      </div>
      <div className="pl-table">
        <div className="pl-row head">
          <div className="sk pl-cell sm" /><div className="sk pl-cell sm" /><div className="sk pl-cell lg" /><div className="sk pl-cell" /><div className="sk pl-cell" />
        </div>
        {[0, 1, 2, 3, 4, 5].map(i => (
          <div key={i} className="pl-row">
            <div className="sk pl-cell sm" /><div className="sk pl-cell sm" /><div className="sk pl-cell lg" /><div className="sk pl-cell" /><div className="sk pl-cell" />
          </div>
        ))}
      </div>
      <div className="pl-status"><div className="spinner" /><span>{message}</span></div>
    </div>
  );
}

/**
 * Loading state for one section of a page (a table, a chart, a list): a spinner and a message
 * centred where the content will appear.
 *   {loading ? <InlineLoader message="Cargando…" /> : <Table …/>}
 */
export function InlineLoader({ message = 'Cargando…', minHeight = 120 }) {
  return (
    <div className="inline-loader" role="status" aria-live="polite" style={{ minHeight }}>
      <div className="spinner" />
      <span>{message}</span>
    </div>
  );
}
